module.exports = __webpack_public_path__ + "img/person-plus.d05c0182.svg";